exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#commonComponent{max-width:200px}#commonComponent .v-select__selection{font-size:12px}.attach-select{display:none}#commonComponent .ribbon-button.ribbon__row{min-height:37px!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-67ad41e4","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/shared/CommonComp.vue
// module id = 1436
// module chunks = 0